import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:50002';

export const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    }
});

// Axios instance to set Authorization header (JWT)
export const setAuthToken = token => {
    if (token) {
        api.defaults.headers['Authorization'] = `Bearer ${token}`;
    } else {
        delete api.defaults.headers['Authorization'];
    }
};
